export default {
  'stock.DeliveryOdMaterial.form.selectReportType':
    'Selecione o Tipo de Relatório',
  'stock.DeliveryOdMaterial.form.selectReportType.delivery': 'Entrega',
  'stock.DeliveryOdMaterial.form.selectReportType.return': 'Devolução',
  'stock.DeliveryOdMaterial.form.selectReportType.employeesVsInputs':
    'Funcionário X Insumos',
  'stock.DeliveryOdMaterial.form.employeesVsInputs':
    'Mostrar estoquista ou funcionários nos itens impressos?',
  'stock.DeliveryOdMaterial.form.selectReportType':
    'Selecione o Tipo de Relatório',
  'stock.DeliveryOdMaterial.form.selectReportType.closing': 'Fechamento',
  'stock.DeliveryOdMaterial.form.selectReportType.deliveryReturn':
    'Entrega/Devolução',
  'stock.DeliveryOdMaterial.form.stockGroupReportBy': 'Agrupar Relatório por',
  'stock.DeliveryOdMaterial.form.stockGroupReportBy.date': 'Data',
  'stock.DeliveryOdMaterial.form.stockGroupReportBy.employee': 'Funcionário',
  'stock.DeliveryOdMaterial.form.type': 'Tipo',
  'stock.DeliveryOdMaterial.form.type.info':
    'Quando selecionado "Estoquista", o relatório de "Entrega" irá filtrar quem está entregando o material/insumo e os relatórios de "Devolução" e "Funcionários x Insumos" irão filtrar quem está recebendo. Quando selecionado "Funcionário" o filtro será o inverso de quem recebe/quem entrega.',
  'stock.DeliveryOdMaterial.form.type.stockist': 'Estoquista',
  'stock.DeliveryOdMaterial.form.type.employee': 'Funcionário',

  'stock.DeliveryOdMaterial.form.moreOptions': 'Mais Opções',
  'stock.DeliveryOdMaterial.form.moreOptions.filterByBudget':
    'Filtrar por Orçamento',
  'stock.DeliveryOdMaterial.form.moreOptions.employees': 'Funcionários',

  'stock.DeliveryOdMaterial.success': 'Sucesso',
  'stock.DeliveryOdMaterial.success.message': 'Entrega de materiais realizada.',
};
